module.exports = __webpack_public_path__ + "img/login.b40432da.jpg";